import _ from 'lodash'

export const creditInformationIsEmpty = (data) => {
    const bisnodeScoring = data?.bisnodeScoring ?? {}
    const paymentIndex = data?.paymentIndex ?? {}

    if (_.isEmpty(bisnodeScoring) && _.isEmpty(paymentIndex)) return true

    const paymentIndexEmpty = !_.some(paymentIndex, (val) => !_.isNil(val?.value))
    const bisnodeScoringEmpty = !_.some(bisnodeScoring, (val) => !_.isNil(val?.value))

    return paymentIndexEmpty && bisnodeScoringEmpty
}
